import { render, staticRenderFns } from "./BemLink.vue?vue&type=template&id=5c303501&lang=pug"
import script from "./BemLink.vue?vue&type=script&lang=js"
export * from "./BemLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports